function EmptyCartIcon(props: any) {
  // #6c63ff
  // #006C4C
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      data-name="Layer 1"
      viewBox="0 0 896 747.971"
      {...props}
    >
      <path
        fill="#2f2e41"
        d="M41.634 712.738c12.428 23.049 38.806 32.943 38.806 32.943s6.227-27.475-6.201-50.524-38.806-32.944-38.806-32.944-6.227 27.476 6.201 50.525z"
      ></path>
      <path
        fill="#006C4C"
        d="M50.177 705.155c22.438 13.5 31.08 40.314 31.08 40.314s-27.738 4.927-50.177-8.573S0 696.582 0 696.582s27.738-4.927 50.177 8.573z"
      ></path>
      <path fill="#f2f2f2" d="M413.248 35.908H553.248V37.908H413.248z"></path>
      <path fill="#f2f2f2" d="M513.249 37.408H515.249V55.908H513.249z"></path>
      <path fill="#f2f2f2" d="M452.248 37.408H454.248V55.908H452.248z"></path>
      <path fill="#f2f2f2" d="M484.248 131.908H624.248V133.908H484.248z"></path>
      <path
        fill="#f2f2f2"
        d="M522.249 113.908H524.249V132.40800000000002H522.249z"
      ></path>
      <path
        fill="#f2f2f2"
        d="M583.249 113.908H585.249V132.40800000000002H583.249z"
      ></path>
      <path fill="#f2f2f2" d="M670.249 176.908H810.249V178.908H670.249z"></path>
      <path fill="#f2f2f2" d="M708.249 158.908H710.249V177.408H708.249z"></path>
      <path fill="#f2f2f2" d="M769.249 158.908H771.249V177.408H769.249z"></path>
      <path fill="#f2f2f2" d="M656.249 640.908H796.249V642.908H656.249z"></path>
      <path fill="#f2f2f2" d="M694.249 622.908H696.249V641.408H694.249z"></path>
      <path fill="#f2f2f2" d="M755.249 622.908H757.249V641.408H755.249z"></path>
      <path fill="#f2f2f2" d="M417.248 319.908H557.248V321.908H417.248z"></path>
      <path fill="#f2f2f2" d="M455.248 301.908H457.248V320.408H455.248z"></path>
      <path fill="#f2f2f2" d="M516.249 301.908H518.249V320.408H516.249z"></path>
      <path fill="#f2f2f2" d="M461.248 560.908H601.248V562.908H461.248z"></path>
      <path fill="#f2f2f2" d="M499.248 542.908H501.248V561.408H499.248z"></path>
      <path fill="#f2f2f2" d="M560.249 542.908H562.249V561.408H560.249z"></path>
      <path fill="#f2f2f2" d="M685.249 487.908H825.249V489.908H685.249z"></path>
      <path fill="#f2f2f2" d="M723.249 469.908H725.249V488.408H723.249z"></path>
      <path fill="#f2f2f2" d="M784.249 469.908H786.249V488.408H784.249z"></path>
      <path
        fill="#2f2e41"
        d="M362.06 702.184L125.274 702.184 125.274 700.481 360.356 700.481 360.356 617.861 145.18 617.861 134.727 596.084 136.263 595.347 146.252 616.157 362.06 616.157 362.06 702.184z"
      ></path>
      <circle cx="156.789" cy="726.033" r="17.887" fill="#3f3d56"></circle>
      <circle cx="333.101" cy="726.033" r="17.887" fill="#3f3d56"></circle>
      <circle cx="540.927" cy="346.153" r="11.073" fill="#3f3d56"></circle>
      <path
        fill="#2f2e41"
        d="M387.385 589.753H121.237L63.648 401.517h383.045l-.349 1.107zm-264.888-1.703h263.639l58.234-184.83H65.95z"
      ></path>
      <path
        fill="#f2f2f2"
        d="M366.61 579.958L132.842 579.958 82.26 413.015 418.701 413.015 418.395 413.998 366.61 579.958z"
      ></path>
      <path
        fill="#2f2e41"
        d="M451.465 384.7L449.818 384.263 461.059 341.894 526.448 341.894 526.448 343.598 462.37 343.598 451.465 384.7z"
      ></path>
      <path fill="#2f2e41" d="M82.258 458.584H427.551V460.288H82.258z"></path>
      <path fill="#2f2e41" d="M101.459 521.344H407.778V523.048H101.459z"></path>
      <path fill="#2f2e41" d="M254.314 402.368H256.018V588.901H254.314z"></path>
      <path
        fill="#2f2e41"
        d="M385.557 570.797H572.486V572.501H385.557z"
        transform="rotate(-86.249 362.441 614.788)"
      ></path>
      <path
        fill="#2f2e41"
        d="M334.457 478.185H336.161V665.114H334.457z"
        transform="rotate(-3.729 -908.232 2868.285)"
      ></path>
      <path fill="#2f2e41" d="M0 745H896V747H0z"></path>
      <path
        fill="#a0616a"
        d="M595.41 61.876s14.62 41.606 5.623 48.007 30.361 58.676 30.361 58.676l47.23-12.802-25.864-43.74s-3.374-43.74-3.374-50.141-53.975 0-53.975 0z"
      ></path>
      <path
        d="M595.41 61.876s14.62 41.606 5.623 48.007 30.361 58.676 30.361 58.676l47.23-12.802-25.864-43.74s-3.374-43.74-3.374-50.141-53.975 0-53.975 0z"
        opacity="0.1"
      ></path>
      <path
        fill="#2f2e41"
        d="M570.874 358.454s-4.268 53.341 0 81.079 10.668 104.549 10.668 104.549 0 145.089 23.47 147.222 40.54 4.268 42.673-4.267-10.668-12.802-4.267-17.07 8.535-19.202 0-36.271 0-189.896 0-189.896l40.54 108.817s4.267 89.613 8.534 102.415-4.267 36.272 10.668 38.406 32.005-10.668 40.54-14.936-12.802-4.267-8.535-6.4 17.07-8.535 12.802-10.669-8.535-104.55-8.535-104.55-11.735-218.699-26.67-227.233-24.537 6.165-24.537 6.165z"
      ></path>
      <path
        fill="#2f2e41"
        d="M609.28 682.77v17.069s-19.203 46.4 0 46.4 34.138 4.808 34.138-1.593v-57.61zM735.165 682.74v17.069s19.203 46.399 0 46.399-34.138 4.808-34.138-1.593v-57.608z"
      ></path>
      <circle cx="625.282" cy="54.408" r="38.406" fill="#a0616a"></circle>
      <path
        fill="#006C4C"
        d="M613.547 125.886s10.668 32.004 27.737 25.604l17.07-6.401 29.87 204.83s-23.47 34.139-57.608 12.802-17.07-236.835-17.07-236.835z"
      ></path>
      <path
        fill="#3f3d56"
        d="M643.418 119.485l9.601-20.27s56.542 26.67 65.077 35.205 8.534 21.337 8.534 21.337l-14.935 53.341s4.267 117.351 4.267 121.619 14.936 27.737 4.267 19.202-12.801-17.069-21.336-4.267-27.738 27.738-27.738 27.738z"
      ></path>
      <path
        fill="#a0616a"
        d="M718.096 273.108l-6.401 59.742s-38.406 34.139-29.871 36.272 12.802-6.4 12.802-6.4 14.935 14.935 23.47 6.4 29.871-89.613 29.871-89.613z"
      ></path>
      <path
        fill="#2f2e41"
        d="M626.1.13c-8.514-.305-17.625-.455-24.804 4.133a36.313 36.313 0 00-8.572 8.392c-6.992 8.838-13.033 19.959-10.436 30.925l3.016-1.176a19.75 19.75 0 01-1.905 8.462c.425-1.235 1.848.762 1.467 2.011l-3.323 10.9c5.462-2.002 12.257 2.053 13.088 7.81.38-12.66 1.693-27.18 11.964-34.593 5.18-3.739 11.735-4.88 18.042-5.893 5.818-.935 11.918-1.827 17.49.088s10.32 7.615 9.056 13.371c2.57-.885 5.443.906 6.713 3.309s1.337 5.237 1.375 7.955c2.74 1.936 5.857-1.908 6.973-5.071 2.62-7.424 4.95-15.328 3.538-23.073s-7.724-15.148-15.597-15.174a5.467 5.467 0 001.422-3.849l-6.49-.548a7.172 7.172 0 004.287-2.26C650.798 8.716 630.313.28 626.1.13z"
      ></path>
      <path
        fill="#3f3d56"
        d="M624.215 113.084s-17.37-17.021-23.62-15.979-14.786 15.979-14.786 15.979-51.207 17.069-49.074 34.138 25.604 100.282 25.604 100.282 19.203 100.282 2.134 110.95 81.079 38.406 83.212 25.604 6.401-140.821 0-160.024-23.47-110.95-23.47-110.95zM698.893 147.222h26.383s18.424 81.08 20.557 89.614 6.401 49.074 4.268 49.074-44.807-8.535-44.807-2.134z"
      ></path>
      <path
        fill="#f2f2f2"
        d="M698 348H597c-9.856-45.34-10.68-89.146 0-131h101c-16.3 41.1-17.318 84.607 0 131z"
      ></path>
      <path
        fill="#a0616a"
        d="M555.938 292.31l29.871 12.803s57.609 8.534 57.609-14.936-57.609-10.668-57.609-10.668l-19.204-6.14z"
      ></path>
      <path
        fill="#3f3d56"
        d="M562.339 134.42l-25.604 6.401-19.203 113.084s-6.4 29.871 4.268 32.005 40.539 19.203 40.539 19.203 4.267-32.005 12.802-32.005l-21.337-17.07 12.802-74.677z"
      ></path>
      <path fill="#f2f2f2" d="M60.248 352.908H200.248V354.908H60.248z"></path>
      <path fill="#f2f2f2" d="M98.249 334.908H100.249V353.408H98.249z"></path>
      <path fill="#f2f2f2" d="M159.249 334.908H161.249V353.408H159.249z"></path>
      <path fill="#f2f2f2" d="M109.249 56.908H249.249V58.908H109.249z"></path>
      <path fill="#f2f2f2" d="M209.249 58.408H211.249V76.908H209.249z"></path>
      <path fill="#f2f2f2" d="M148.249 58.408H150.249V76.908H148.249z"></path>
      <path fill="#f2f2f2" d="M250.249 253.908H390.249V255.908H250.249z"></path>
      <path fill="#f2f2f2" d="M350.248 255.408H352.248V273.908H350.248z"></path>
      <path fill="#f2f2f2" d="M289.248 255.408H291.248V273.908H289.248z"></path>
      <path fill="#f2f2f2" d="M12.248 252.908H152.248V254.908H12.248z"></path>
      <path fill="#f2f2f2" d="M112.249 254.408H114.249V272.908H112.249z"></path>
      <path fill="#f2f2f2" d="M51.248 254.408H53.248V272.908H51.248z"></path>
      <path fill="#f2f2f2" d="M180.249 152.908H320.249V154.908H180.249z"></path>
      <path fill="#f2f2f2" d="M218.249 134.908H220.249V153.408H218.249z"></path>
      <path fill="#f2f2f2" d="M279.248 134.908H281.248V153.408H279.248z"></path>
    </svg>
  );
}

export default EmptyCartIcon;
